import { resolveComponent, createBlock, openBlock, withCtx, createVNode, normalizeProps, guardReactiveProps, createTextVNode, toDisplayString } from "vue";
/* empty css                    */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
import { VIcon } from "vuetify/components/VIcon";
import { VListItem, VListItemTitle } from "vuetify/components/VList";
import { VMenu } from "vuetify/components/VMenu";
const _sfc_main = {
  name: "DateFilterItem",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: "lets-icons:calendar-duotone"
    },
    showDate: {
      type: Boolean,
      default: true
    },
    range: {
      type: Boolean,
      default: false
    },
    multiDates: {
      type: Boolean,
      default: false
    },
    autoApply: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      menu: false
    };
  },
  computed: {
    value: {
      get() {
        return (this.range || this.multiDates ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : Array.isArray(this.modelValue) ? this.modelValue[0] : this.modelValue) || null;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    },
    valueStr() {
      if (!this.value) {
        return null;
      }
      const values = [];
      const dates = Array.isArray(this.value) ? this.value : [this.value];
      for (const date of dates) {
        values.push(this.$moment(date).format("ll"));
      }
      return values.join(" - ");
    }
  }
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = resolveComponent("b-icon");
  const _component_b_date_edit = resolveComponent("b-date-edit");
  return openBlock(), createBlock(VMenu, {
    modelValue: $data.menu,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.menu = $event),
    offset: "8",
    "close-on-content-click": false,
    location: "end"
  }, {
    activator: withCtx(({ props }) => [
      createVNode(VListItem, normalizeProps(guardReactiveProps(props)), {
        prepend: withCtx(() => [
          createVNode(_component_b_icon, {
            size: "20",
            class: "mr-2",
            icon: $props.icon
          }, null, 8, ["icon"])
        ]),
        append: withCtx(() => [
          createVNode(VIcon, null, {
            default: withCtx(() => _cache[3] || (_cache[3] = [
              createTextVNode("mdi-chevron-right")
            ])),
            _: 1,
            __: [3]
          })
        ]),
        default: withCtx(() => [
          createVNode(VListItemTitle, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString($props.label) + " " + toDisplayString($props.showDate && $options.valueStr ? `(${$options.valueStr})` : ""), 1)
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1040)
    ]),
    default: withCtx(() => [
      createVNode(_component_b_date_edit, {
        modelValue: $options.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event) => $options.value = $event),
          _cache[1] || (_cache[1] = ($event) => $data.menu = false)
        ],
        range: $props.range,
        inline: true,
        "multi-dates": $props.multiDates
      }, null, 8, ["modelValue", "range", "multi-dates"])
    ]),
    _: 1
  }, 8, ["modelValue"]);
}
const DateFilterItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  DateFilterItem as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
